import { defineAsyncComponent } from "vue";
const FilePickerVue = defineAsyncComponent(() => import("./FilePicker-CSmrMOEO.mjs"));
export {
  FilePickerVue
};
